import { creditInvoiceDto, ICreditInvoiceDto } from 'src/assets/common/models/credit-invoice-dto.g';
import { money_format, number_format } from './credits-format';

// Printbare factuur van een aankoop van credits (alleen aankopen worden gefactureerd). Opent een eigen venster met
// een kale HTML-pagina en de afdrukdialoog, zodat de app-opmaak niet meeprint. Alle waarden worden ge-escaped.
export function creditInvoice_print(invoice: ICreditInvoiceDto): void {
    const __window = window.open('', '_blank');
    if (!__window) return;

    const __e = (value: unknown) => String(value ?? '')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    const __date = invoice[creditInvoiceDto.invoiceDate]
        ? new Intl.DateTimeFormat(undefined, { dateStyle: 'long' }).format(new Date(`${invoice[creditInvoiceDto.invoiceDate]}T00:00:00`))
        : '';
    // Gericht aan het domain (saldo per domain): naam, adres (meerdere regels), btw-nummer, t.a.v. de owner, e-mail.
    const __addressee = [
        __e(invoice[creditInvoiceDto.billToName]),
        ...String(invoice[creditInvoiceDto.billToAddress] ?? '').split('\n').filter(l => l.trim()).map(__e),
        invoice[creditInvoiceDto.billToVatNumber] ? `Btw-nummer: ${__e(invoice[creditInvoiceDto.billToVatNumber])}` : '',
        invoice[creditInvoiceDto.attention] ? `t.a.v. ${__e(invoice[creditInvoiceDto.attention])}` : '',
        __e(invoice[creditInvoiceDto.billToEmail]),
    ].filter(l => l).join('<br>');

    __window.document.write(`<!doctype html>
<html><head><meta charset="utf-8"><title>Factuur ${__e(invoice[creditInvoiceDto.nr])}</title>
<style>
  body { font-family: Arial, Helvetica, sans-serif; color: #222; max-width: 640px; margin: 40px auto; padding: 0 16px; }
  h1 { font-size: 22px; margin: 0 0 24px; }
  table { width: 100%; border-collapse: collapse; margin: 24px 0; }
  td { padding: 6px 0; border-bottom: 1px solid #ddd; }
  td.num { text-align: right; font-variant-numeric: tabular-nums; }
  tr.total td { font-weight: bold; border-bottom: 2px solid #222; }
  .muted { color: #666; font-size: 13px; }
</style></head>
<body>
  <h1>Factuur ${__e(invoice[creditInvoiceDto.nr])}</h1>
  <p>${__addressee}</p>
  <p class="muted">Factuurdatum: ${__e(__date)}</p>
  <table>
    <tr><td>${__e(number_format(invoice[creditInvoiceDto.credits]))} credits à ${__e(money_format(invoice[creditInvoiceDto.creditPrice]))}</td>
        <td class="num">${__e(money_format(invoice[creditInvoiceDto.amount]))}</td></tr>
    <tr><td>Btw ${__e(invoice[creditInvoiceDto.vatPerc])}%</td><td class="num">${__e(money_format(invoice[creditInvoiceDto.vatAmount]))}</td></tr>
    <tr class="total"><td>Totaal</td><td class="num">${__e(money_format(invoice[creditInvoiceDto.total]))}</td></tr>
  </table>
  ${invoice[creditInvoiceDto.note] ? `<p class="muted">${__e(invoice[creditInvoiceDto.note])}</p>` : ''}
  <script>window.onload = () => window.print();</script>
</body></html>`);
    __window.document.close();
}
